var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityDailyActivityNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#d4bff6;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_daily_activity_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.61,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.3,230.82H349.61c.32,3.6.49,7.26.49,10.94a121.37,121.37,0,1,1-22.53-70.41c.49.69,1,1.39,1.45,2.09a16.21,16.21,0,0,0,14.54-16v-.14l.06-8.15h.49l-.48-.59a149,149,0,0,0-32.17-29.52,147.2,147.2,0,0,0-82.87-25.41c-81.67,0-148.12,66.45-148.12,148.12s66.45,148.11,148.12,148.11S376.7,323.43,376.7,241.76Q376.7,236.24,376.3,230.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.66,276.65a10.45,10.45,0,0,0-7.65-3.09H188.1l12.41-13.19a76.26,76.26,0,0,0,12.43-17.56,41.19,41.19,0,0,0,4.77-18.51,34,34,0,0,0-4.07-16.63A29.74,29.74,0,0,0,201.94,196a34.9,34.9,0,0,0-31.73-.8,44.46,44.46,0,0,0-12.89,9,33.15,33.15,0,0,0-4.51,5.35A10.75,10.75,0,0,0,151,215.3a9.93,9.93,0,0,0,3.53,7.47,11,11,0,0,0,7.62,3.14,10.64,10.64,0,0,0,8.76-4.52,26.46,26.46,0,0,1,6.52-6.29,11.27,11.27,0,0,1,6.27-2.15,10.6,10.6,0,0,1,7.86,3.56A11.66,11.66,0,0,1,195,225a19.05,19.05,0,0,1-2.57,8.7,49.72,49.72,0,0,1-7.5,10.32l-29.72,31.75a11.54,11.54,0,0,0-3.3,8.14,10.88,10.88,0,0,0,2.88,7.71,10.31,10.31,0,0,0,7.86,3.17H209a10.55,10.55,0,0,0,7.61-3,10.16,10.16,0,0,0,3.13-7.48,10.45,10.45,0,0,0-3.09-7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.11,247.65V204.53a11.25,11.25,0,0,0-3.2-8.1,10.73,10.73,0,0,0-8-3.32,11.39,11.39,0,0,0-9.22,4.41l-43.07,52.75a11.34,11.34,0,0,0-2.77,7.44,10.63,10.63,0,0,0,3.59,7.94,11.16,11.16,0,0,0,7.7,3.21h32.35v14.48a11.2,11.2,0,0,0,3.19,8.1,10.7,10.7,0,0,0,8,3.33,11.27,11.27,0,0,0,11.42-11.43V247.65Zm-22.57-15.4v15.4H261.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 363.01,
    cy: 230.54,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344,103.68l-.35,44.89v.59l-.06,8.15v.14a16.21,16.21,0,0,1-14.54,16c-.48,0-1,.07-1.45.08h-.34a16.2,16.2,0,0,1-16.07-16.33l0-4.46.09-11.74.18-21.94.13-15.63a16.2,16.2,0,1,1,32.39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.56,157.31v.14a16.21,16.21,0,0,1-14.54,16c-.48,0-1,.07-1.45.08h-.34l-53.76-.43a16.2,16.2,0,1,1,.25-32.4l22.52.18,15,.12,16.21.13a16.21,16.21,0,0,1,16.07,16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.62,149.16l-.06,8.15v.14a16.21,16.21,0,0,1-14.54,16c-.48,0-1,.07-1.45.08V149.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.57,523.52a58.33,58.33,0,0,1-58.26-58.26V418.1H263a56.8,56.8,0,1,1,0-113.59h48.36V257.42a58.26,58.26,0,1,1,116.52,0v47.09H484a56.8,56.8,0,1,1,0,113.59H427.83v47.16A58.33,58.33,0,0,1,369.57,523.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.57,214.16a43.39,43.39,0,0,1,43.26,43.26v62.09H484a41.8,41.8,0,1,1,0,83.59H412.83v62.16a43.39,43.39,0,0,1-43.26,43.26h0a43.38,43.38,0,0,1-43.26-43.26V403.1H263a41.8,41.8,0,1,1,0-83.59h63.36V257.42a43.38,43.38,0,0,1,43.26-43.26h0m0-30a73.34,73.34,0,0,0-73.26,73.26v32.09H263a71.8,71.8,0,1,0,0,143.59h33.36v32.16a73.26,73.26,0,0,0,146.52,0V433.1H484a71.8,71.8,0,1,0,0-143.59H442.83V257.42a73.35,73.35,0,0,0-73.26-73.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDailyActivityNewEntry);
export default __webpack_public_path__ + "static/media/activity_daily_activity_new_entry.c4631ca66bf31bf2a2f2ebd7b4e04de1.svg";
export { ForwardRef as ReactComponent };